import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getDealPerson, patchDealPerson } from "src/store/dataService/actions/deal";
import { getRegion } from "src/utils";
import { Deal } from "Types/api/Deal";
import ReserveVehicle from "./ReserveVehicle";

function mapStateToProps({ account, deal }: ApplicationStore) {
    const region = getRegion(account);

    return {
        account,
        person: deal.person,
        region,
        uuid: deal.uuid as string,
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    getDealPerson: (uuid: string) => dispatch(getDealPerson(uuid)),
    patchDealPerson: (uuid: string, data: Deal["person"]) => dispatch(patchDealPerson(uuid, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReserveVehicle);
